import { Pipe, PipeTransform } from '@angular/core';

// DOVE-2404 — the API still returns the raw DTS names ('Scheduled', 'On-Board'), and
// logic compares against those; only what the user sees is renamed.
export function dtsDisplayLabel<T extends string | null | undefined>(value: T): T | string {
	if (value === 'On-Board') {
		return 'Ready';
	} else if (value === 'Scheduled') {
		return 'Not Ready';
	}
	return value;
}

@Pipe({
	name: 'statusTag',
	standalone: true
})
export class StatusTagPipe implements PipeTransform {
	transform<T extends string | null | undefined>(value: T): T | string {
		return dtsDisplayLabel(value);
	}
}
